import { Alert } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import Text from 'antd/lib/typography/Text';

const BatchingInfo: React.FC = () => {
  return (
    <>
      <Alert
        icon={false}
        type="info"
        message="Batching Help"
        description={
          <>
            <Paragraph>
              Batched items are stored in the
              <Text code>{'_items'}</Text> array.
            </Paragraph>

            <Paragraph>
              Count the batched items:
              <br />
              <Text code>{'{{ _items.size }}'}</Text>
            </Paragraph>

            <Paragraph>
              Print a mergeTag from the first item:
              <Text code>{'{{ _items[0].name }}'}</Text>
            </Paragraph>

            <Paragraph>
              Else/if based on batch size:
              <pre style={{ fontSize: 12 }}>
                {
                  'You have {{ _items.size }} comment{% if _items.size > 1 %}s{% endif %}.'
                }
              </pre>
            </Paragraph>
          </>
        }
        showIcon
      ></Alert>
    </>
  );
};

export default BatchingInfo;
